class CodeltyProductSticky {
  constructor() {
    this.root = document.querySelector('[data-codelty-product-sticky]');
    if (!this.root) return;

    this.buyAnchor = document.querySelector('[data-codelty-product-buy]');
    this.productInfo = document.querySelector('product-info');
    this.init();
  }

  init() {
    this.bindCommerceCta();
    this.bindVisibility();
    this.bindVariantSync();
    this.syncContentState();
    this.syncSubmitState();
    CodeltyCommerceCta?.init(this.root);
  }

  getSubmitButton() {
    return document.querySelector('.codelty-product-page [name="add"]');
  }

  bindCommerceCta() {
    const stickyButton = this.root.querySelector('[data-codelty-sticky-submit]');
    const submit = this.getSubmitButton();

    if (stickyButton && submit && window.CodeltyCommerceCta) {
      CodeltyCommerceCta.registerMirror(stickyButton, submit);
    }

    stickyButton?.addEventListener('click', () => {
      const source = this.getSubmitButton();
      if (source && !source.disabled) source.click();
    });
  }

  bindVisibility() {
    if (!this.buyAnchor) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.root.hidden = false;
        const visible = !entry.isIntersecting;
        this.root.classList.toggle('is-visible', visible);
        this.root.toggleAttribute('aria-hidden', !visible);
        document.body.classList.toggle('has-codelty-sticky-bar', visible);
        if (visible) {
          document.documentElement.style.setProperty('--codelty-sticky-offset', `${this.root.offsetHeight}px`);
        } else {
          document.documentElement.style.removeProperty('--codelty-sticky-offset');
        }
      },
      { threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );

    this.observer.observe(this.buyAnchor);
  }

  bindVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = this.productInfo?.dataset?.section;
      if (!sectionId || event.data?.sectionId !== sectionId) return;

      window.requestAnimationFrame(() => {
        this.syncContentState();
        this.syncSubmitState();
        this.pulse(this.root.querySelector('[data-codelty-sticky-variant]'));
        this.pulse(this.root.querySelector('[data-codelty-sticky-price]'));
        this.pulse(this.root.querySelector('[data-codelty-sticky-media]'));
      });
    });
  }

  syncContentState() {
    const variantEl = this.root.querySelector('[data-codelty-sticky-variant]');
    if (variantEl) {
      variantEl.hidden = variantEl.textContent.trim().length === 0;
    }

    const mediaEl = this.root.querySelector('[data-codelty-sticky-media]');
    if (mediaEl) {
      mediaEl.hidden = !mediaEl.querySelector('img');
    }
  }

  syncSubmitState() {
    const submit = this.getSubmitButton();
    const stickyButton = this.root.querySelector('[data-codelty-sticky-submit]');
    if (!submit || !stickyButton) return;

    if (stickyButton.classList.contains('loading') || stickyButton.classList.contains('is-success')) return;

    stickyButton.disabled = submit.disabled;
    if (submit.hasAttribute('aria-disabled')) {
      stickyButton.setAttribute('aria-disabled', submit.getAttribute('aria-disabled'));
    } else {
      stickyButton.removeAttribute('aria-disabled');
    }

    const sourceLabel = submit.querySelector('[data-codelty-cta-label]');
    const stickyLabel = stickyButton.querySelector('[data-codelty-cta-label]');
    if (sourceLabel && stickyLabel) {
      stickyLabel.textContent = sourceLabel.textContent;
    }
  }

  pulse(element) {
    if (!element) return;
    element.classList.remove('is-updating');
    void element.offsetWidth;
    element.classList.add('is-updating');
    window.setTimeout(() => element.classList.remove('is-updating'), 320);
  }

  destroy() {
    this.observer?.disconnect();
    this.variantUnsubscriber?.();
    document.body.classList.remove('has-codelty-sticky-bar');
    document.documentElement.style.removeProperty('--codelty-sticky-offset');
  }
}

const bootProductSticky = () => {
  if (window.__codeltyProductSticky) window.__codeltyProductSticky.destroy();
  window.__codeltyProductSticky = new CodeltyProductSticky();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootProductSticky);
} else {
  bootProductSticky();
}

document.addEventListener('product-info:loaded', bootProductSticky);
